import { TableBody, Typography } from "@material-ui/core";
import React from "react";

import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../../../../../partials/datatable/styles";
import { getLabelAndColorEmail } from "../../../../helpers/getLabelAndColoFromSatatusEmail";

export const TableBodyContent = ({ logsList }) => {
  console.log(logsList, "TABLE BODY");
  return (
    <TableBody
      style={{
        textAlign: "left",
      }}
    >
      {logsList.map((row) => (
        <StyledTableRow key={row.id}>
          <StyledTableCell
            style={{
              textAlign: "left",
            }}
          >
            {row.responsible}
          </StyledTableCell>
          <StyledTableCell
            style={{
              textAlign: "left",
            }}
          >
            {row.type}
          </StyledTableCell>
          <StyledTableCell
            style={{
              textAlign: "left",
            }}
          >
            <Typography
              style={{
                backgroundColor: getLabelAndColorEmail(row.note).color,
                display: "inline-block",
                padding: "4px 6px",
                margin: "0 4px",
                borderRadius: "4px",
                fontWeight: "500",
                color: getLabelAndColorEmail(row.note).textColor,
              }}
            >
              {getLabelAndColorEmail(row.note).label}
            </Typography>
          </StyledTableCell>
          <StyledTableCell
            style={{
              textAlign: "start",
            }}
          >
            {new Date(row.createdAt)
              .toLocaleString("pt-BR")
              .replace(",", " - ")}
          </StyledTableCell>
        </StyledTableRow>
      ))}
    </TableBody>
  );
};
